/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgWeb3 = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.563 10.633a.712.712 0 1 0 1.232.712.712.712 0 0 0-1.232-.712ZM8 1.5a.712.712 0 1 0 0 1.423A.712.712 0 0 0 8 1.5ZM6.894 3.321l-.5-.866-3.81 2.2-.25.432v4.389h1V5.953l.87.502.5-.866-.87-.502 3.06-1.766ZM3.941 9.852l.5.866 3.073-1.774v2.124h1V8.944l3.045 1.758.5-.866-3.045-1.758 1.84-1.062-.5-.866-1.84 1.062V3.654h-1v3.558L5.674 6.15l-.5.866 1.84 1.062-3.073 1.774Zm.478 1.553-.5.866 3.845 2.22h.5l3.817-2.204-.5-.866-3.067 1.771V12.19h-1v1.003L4.42 11.405Zm9.274-6.318V9.47h-1V5.953l-.868.502-.5-.866.868-.502-3.08-1.778.5-.867 3.83 2.212.25.433ZM3.436 10.672a.712.712 0 1 0-1.233.712.712.712 0 0 0 1.233-.712Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "web3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))));

export default SvgWeb3;